import React from 'react';

export default function BacBlock3Engine() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-16 bg-surface border-b border-line">
      <div className="max-w-[1000px] mx-auto">
        <div className="mb-24 max-w-3xl">
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            Transformando evidencia en trabajo ejecutable.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            El modelo separa rigurosamente los conceptos. Cada paso garantiza que el esfuerzo termine en un hito verificable o una reevaluación.
          </p>
        </div>
        <div className="max-w-[1024px] w-full">
          <div className="flex flex-col md:flex-row items-stretch md:items-center justify-between gap-2 md:gap-3">
            <div className="flex-1 flex flex-col items-start gap-2 border-l-2 border-line pl-6">
              <span className="text-[14px] font-semibold text-brand">Paso 01</span>
              <span className="text-[20px] font-bold text-ink">Evidencia</span>
              <span className="text-[14px] text-ink-soft leading-relaxed mt-2">No es una regla. Son los datos de partida.</span>
            </div>
            <div className="hidden md:block text-ink-soft/30 font-bold text-[22px] text-[rgb(102,51,255)]">→</div>
            <div className="flex-1 flex flex-col items-start gap-2 border-l-2 border-line pl-6">
              <span className="text-[14px] font-semibold text-brand">Paso 02</span>
              <span className="text-[20px] font-bold text-ink">Prioridad</span>
              <span className="text-[14px] text-ink-soft leading-relaxed mt-2">Decisión operacional. No garantiza capacidad.</span>
            </div>
            <div className="hidden md:block text-ink-soft/30 font-bold text-[22px] text-[rgb(102,51,255)]">→</div>
            <div className="flex-1 flex flex-col items-start gap-2 border-l-2 border-brand p-6 bg-brand/5">
              <span className="text-[14px] font-semibold text-brand">Paso 03</span>
              <span className="text-[20px] font-bold text-brand">Próxima acción</span>
              <span className="text-[14px] text-ink-soft leading-relaxed mt-2">La operación conectada a los recursos de la red.</span>
            </div>
            <div className="hidden md:block text-ink-soft/30 font-bold text-[22px] text-[rgb(102,51,255)]">→</div>
            <div className="flex-1 flex flex-col items-start gap-2 border-l-2 border-line pl-6">
              <span className="text-[14px] font-semibold text-brand">Paso 04</span>
              <span className="text-[20px] font-bold text-ink">Verificación</span>
              <span className="text-[14px] text-ink-soft leading-relaxed mt-2">Resultado y reevaluación para el próximo ciclo.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
